import { Injectable } from '@angular/core';
import {HttpService} from '@api/http/http.service';
import {IDefaultListResponse} from '@core/http/models/http-models';
import {IShopItem} from '@api/models/shop/shop-item';

@Injectable({
  providedIn: 'root'
})
export class KroneHttpService {

  constructor(private http: HttpService) { }

  public async getShopItems(): Promise<IDefaultListResponse<IShopItem>> {
    return this.http.get<IDefaultListResponse<IShopItem>>(['krone/widget/shop']);
  }
}
